import Request from "@/common/net/request.js";
const request = new Request();
// 获取列表
export function getPage(data) {
  return request.send({
    url: `/pmy/sys/user/page`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}
// 添加
export function addInfo(data) {
  return request.send({
    url: `/pmy/sys/user`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}

// 编辑
export function editInfo(data) {
  return request.send({
    url: `/pmy/sys/user`,
    method: "put",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}

// 删除
export function deleteInfo(userId) {
  return request.send({
    url: `/pmy/sys/user?userId=${userId}`,
    method: "delete",
  });
}
// 详情
export function detailInfo(userId) {
  return request.send({
    url: `/pmy/sys/user?userId=${userId}`,
    method: "get",
  });
}

// 获取公司下的调度人员
export function getUserDispatchers(companyId) {
  return request.send({
    url: `/pmy/sys/user/dispatchers?companyId=${companyId}`,
    method: "get",
  });
}

// 获取公司下的车队长
export function getUserVehicleLeaders(companyId) {
  return request.send({
    url: `/pmy/sys/user/vehicle-leaders?companyId=${companyId}`,
    method: "get",
  });
}
// 通过旧密码修改密码
export function updatePassByOld(data) {
  return request.send({
    url: `/pmy/sys/user/pwd/by-old`,
    method: "put",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}

// 重置密码
export function resetPass(data) {
  return request.send({
    url: `/pmy/sys/user/reset-pwd`,
    method: "put",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}

// WEB端--通过短信修改密码
export function updatePassByPhone(data) {
  return request.send({
    url: `/pmy/sys/user/web/pwd/by-phone`,
    method: "put",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}
